<template>
  <v-card :loading="loading" class="pa-2" flat>
    <v-card-title>
      <!--                                    v-if="$can('transaction_create')"-->
      <v-btn v-status="'content_create'" class="btn-add-with-text" @click="addAccount = true">
        <v-icon>mdi-plus</v-icon>
        افزودن حساب ادمین
      </v-btn>
      <add-bank-account ref="add-acc" v-model="addAccount" :selected.sync="selectedAccount"
                        @fetch="fetchAccounts"/>
    </v-card-title>

    <custom-popup v-model="changeDialog.open" :cons="cons" hide-overlay max-width="600">
      <v-card flat>
        <v-card-title>لطفا برای ادامه و تایید درخواست یک حساب مبدا مشخص نمایید.</v-card-title>

        <v-card-text>
          <v-autocomplete v-model="selectedAccount" :items="accounts" :loading="accLoading" label="انتخاب حساب"
                          outlined>
            <template v-slot:prepend-inner>
              <v-img :src="banksPrefix?.icon" contain width="48"/>
            </template>

            <template v-slot:item="data">
              <v-list-item-avatar>
                <v-img :src="data.item.icon"/>
              </v-list-item-avatar>
              <v-list-item-title v-text="data.item.text"/>
              <v-list-item-action>
                <v-btn icon @click.stop="deleteAccount(data.item.id)">
                  <v-icon color="red">mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </template>
          </v-autocomplete>
           <v-file-input
              v-model="receiptImage"
              label="آپلود تصویر فیش/سند"
              accept="image/*"
              prepend-icon="mdi-image-plus"
              outlined
              dense
              hide-details
              class="mt-3"
          ></v-file-input>
          <div v-if="receiptImage" class="d-flex align-center mt-2">
            <v-switch
                v-model="showPreview"
                label="نمایش تصویر"
                dense
                hide-details
                class="mt-0"
            ></v-switch>

            <v-spacer></v-spacer>
            <v-btn
                color="error"
                icon
                small
                @click="removeImage"
                title="حذف تصویر"
            >
              <v-icon left>mdi-delete</v-icon>
            </v-btn>
          </div>
          <v-expand-transition>
            <div v-if="showPreview && previewUrl" class="mt-3 text-center">
              <v-img
                  :src="previewUrl"
                  max-height="200"
                  contain
                  class="grey lighten-4 rounded elevation-1"
              ></v-img>
            </div>
        </v-expand-transition>
        </v-card-text>

        <template v-if="!!selectedAccountDetails">
          <v-card-title class="font-size-h6 pt-0">
            مشخصات حساب:
          </v-card-title>
          <v-card-subtitle>
            <v-row no-gutters>
              <v-col class="pa-1" cols="12" md="4">
                <b>{{ selectedAccountDetails.ownerName }}</b>
              </v-col>
              <v-col class="pa-1" cols="12" md="8">
                <b>{{ selectedAccountDetails.ownerLastName }}</b>
              </v-col>

              <v-col class="pa-1" cols="12" md="4">
                شماره کارت:
              </v-col>
              <v-col class="pa-1" cols="12" md="8">
                <b>{{ selectedAccountDetails.cardNumber }}</b>
              </v-col>

              <v-col class="pa-1" cols="12" md="4">
                شماره حساب:
              </v-col>
              <v-col class="pa-1" cols="12" md="8">
                <b>{{ selectedAccountDetails.accountNumber }}</b>
              </v-col>

              <v-col class="pa-1" cols="12" md="4">
                بانک:
              </v-col>
              <v-col class="pa-1" cols="12" md="8">
                <b>{{ selectedAccountDetails.bankName }}</b>
              </v-col>

              <v-col class="pa-1" cols="12" md="4">
                شماره شبا:
              </v-col>
              <v-col class="pa-1" cols="12" md="8">
                IR<b>{{ selectedAccountDetails.sheba }}</b>
              </v-col>
            </v-row>
          </v-card-subtitle>
        </template>
      </v-card>
    </custom-popup>

    <v-divider/>
    <data-table
        :columns="columns"
        :data="data"
        :debounce-delay="5000"
        :per-page="perPages"
        :translate="translates"
        orderDir="desc"
        @on-table-props-changed="reloadTable">
        
      </data-table>
  </v-card>
</template>

<script>
import {mapActions} from 'vuex'
import Btn from "@/view/pages/categories/Btn";
import AddBankAccount from "@/view/pages/admin/transferRequest/addBankAccount";
import statusComponent from "@/view/pages/admin/confirm/statusComponent";
import ImageThumbnail from "./ImageThumbnail.vue"; 

export default {
  components: {AddBankAccount,ImageThumbnail},

  data() {
    return {
    imageDialog: false,
    selectedImageUrl: null,
      receiptImage: null, 
      showPreview: false, 
      previewUrl:null,
      accounts: [],
      accLoading: false,
      addAccount: false,
      banksInfo: [],
      cons: {
        title: 'تایید درخواست',
        buttons: [
          {type: 'submit', handler: this.changeStatus, disabled: () => !this.selectedAccount}
        ]
      },
      changeDialog: {
        open: false,
        id: null,
        to: null
      },
      url: 'admin/transferRequest',
      columns: [
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          colStyle: 'width: 100px;'
        },
        {
          label: 'مبلغ',
          name: 'amount',
          transform: (value) => {
            return this.persianNum(this.currency(Math.floor(value.data.amount.toString())));
          }
        },
        {
          label: 'کاربر',
          name: 'user',
          transform: (value) => {
            return value.data.user == null ? '<p class="text-danger">مشخص نشده</p>' : value.data.user.name + " " + value.data.user.lastName;
          },
        },
        {
          label: 'از حساب',
          name: 'from_account',
          transform: (value) => {
            return value.data.from_account == null
                ? '<p class="text-danger">مشخص نشده</p>'
                : value.data.from_account.bankName + ' - ' + value.data.from_account.ownerName + " " + value.data.from_account.ownerLastName;
          },
        },
        {
          label: 'به حساب',
          name: 'to_account',
          transform: (value) => {
            return value.data.to_account == null ? '<p class="text-danger">ندارد</p>' : value.data.to_account.ownerName + " " + value.data.to_account.ownerLastName;
          },
        },
        {
          label: 'وضعیت',
          name: 'status',
          transform: (val) => {
            return this.$options.filters.requestStatus(val.data.status);
          },
          component: statusComponent
        },
        {
          label: 'تاریخ درخواست',
          name: 'created_at',
          transform: (val) => {
            return this.$options.filters.longDate(val.data.created_at)
          }
        },
        {
          label: 'تاریخ ویرایش',
          name: 'updated_at',
          transform: (val) => {
            return this.$options.filters.longDate(val.data.updated_at)
          }
        },
        {
          label: 'تصویر فیش/ سند',
            name: 'image',
            transform: (val) => {
              return val.data.image || null;
            },
            component: ImageThumbnail,
            event: 'open-modal',
            handler: this.openImageModal       
       },
        {
          label: 'عملیات',
          name: 'actions',
          type: 'html',
          component: Btn,
          handler: this.action,
          event: 'action',
          meta: {
            permission_prefix: 'transfer_request_',
          }

        },
      ],
      data: {},
      loading: false,
      intro: "0",
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
      },
      reqLoading: false,
      selectedAccount: null,
      query: {sort: 'id', order: 'desc', limit: 25, s: ''},
    }
  },
watch: {
  receiptImage(newFile) {
    if (newFile) {
      this.previewUrl = URL.createObjectURL(newFile);
      this.showPreview = true; 
    } else {
      this.previewUrl = null;
      this.showPreview = false;
    }
  }
},

  created() {
    this.getData(this.url)
  },

  computed: {
    banksPrefix() {
      let arr = this.banksInfo,
          str = ''
      if (this.addAccount)
        str = this.obj.cardNumber
      else
        str = this.accounts?.find(item => item.id === this.selectedAccount)?.cardNumber

      return arr.find(item =>
          item.prefix.includes(str?.substring(0, 6)))
    },
    selectedAccountDetails() {
      return this.data?.data?.find(a => a.to === this.changeDialog.to)?.to_account
    }
  },

  methods: {
    ...mapActions('ContentIndex', [
      'fetchIndexData',
      'setQuery',
      'resetState'
    ]),
     removeImage() {
    this.receiptImage = null;
     },
    getData(url = this.url, options = this.tableProps) {
      this.loading = true
      this.requestApiGet(this.url, options)
          .then(response => {
            console.log(response, "response")
            this.data = response.data
            this.loading = false
            this.$nextTick(() => {
              this.banksInfo = this.$refs["add-acc"]?.banksInfo
            })
          })
    },
    reloadTable(tableProps) {
      this.getData(this.url, tableProps)
    },
    fetchAccounts() {
      this.accLoading = true

      this.requestApiGet('admin/account')
          .then(({data}) => {
            try {
              this.accounts = data.data.data.map(item => {
                return {
                  ...item,
                  text: item.bankName + ' - ' + item.ownerName + ' ' + item.ownerLastName,
                  value: item.id,
                  icon: this.banksInfo.find(value =>
                      value.prefix.includes(item.cardNumber.substring(0, 6)))?.icon
                }
              })
            } catch (e) {
              console.error('error in accounts: ', e)
            }
          })
          .catch(({response}) => console.log('error in get admin accounts: ', response))
          .finally(() => this.accLoading = false)
    },
    action(data, type) {
      this[type](data)
    },
    async reject(data) {
      if (await this.$modal.yesNo('رد کردن درخواست', 'آیا از رد کردن درخواست مورد نظر اطمینان دارید ؟')) {
        this.changeStatus(data.id, 'reject')
      }
    },
    accept(data) {
      if (this.accounts.length === 0)
        this.fetchAccounts()

      this.changeDialog = {
        open: true,
        id: data.id,
        to: data.to
      }
    },
    changeStatus(id, status = 'accept') {
      this.reqLoading = true

      let formData = new FormData();
      formData.append('status', status);
      formData.append('id', id ?? this.changeDialog.id);
      
      if (this.selectedAccount) {
        formData.append('from', this.selectedAccount);
      }
      
      if (!!this.receiptImage) {
        formData.append('image', this.receiptImage);
      }

      this.requestApiPost('admin/transferRequest', formData)
          .then(response => {
            this.receiptImage = null; 
            this.previewUrl = null;
            this.showPreview = false;
            this.changeDialog.open = false;
            this.reloadTable(this.tableProps)
            this.$toast.success('درخواست مورد نظر با موفقیت تغییر یافت.')
          })
          .catch(({response}) => console.log('error change status of transfer request: ', response))
          .finally(() => this.reqLoading = false)
    },
    async deleteAccount(id) {
      if (await this.$modal.yesNo('حذف حساب از لیست ؟')) {
        this.loading = true
        this.requestApiDelete(`admin/account/${id}`)
            .then(({data}) => {
              this.fetchAccounts()
            })
            .catch(({response}) => console.error('error in delete account: ', response))
            .finally(() => this.loading = false)
      }
    },
  },

  beforeDestroy() {
    this.resetState()
  }
}
</script>

<style scoped>
.v-autocomplete >>> .v-input__prepend-inner {
  align-self: center;
  margin: 0 !important;
}
</style>
